import { AccountBalanceStats, SecurityCurrencyAssetPair } from '@tassat/fred-extended-definitions';
import { stripPrefix } from '@tassat/utility';

import { IAddOnFormErrors, IAddOnFormValues } from './types';

export const validateAddOn = async (
    values: IAddOnFormValues,
    opts: {
        errors: IAddOnFormErrors;
        securityAvailableBalance?: AccountBalanceStats;
        assetPair?: SecurityCurrencyAssetPair;
    }
): Promise<IAddOnFormErrors> => {
    const { errors, securityAvailableBalance, assetPair } = opts;

    const assetAmount = Number(stripPrefix(values.AssetAmount, `${assetPair?.security?.Ticker} `)
        .replace(/,/g, ''));

    if (!assetAmount) {
        errors.AssetAmount = 'Please enter an amount';
    }

    if (securityAvailableBalance && assetAmount > Number(securityAvailableBalance.availableBalance)) {
        errors.AssetAmount = `Amount must not exceed the available ${assetPair?.security?.Ticker ?? ''} balance of the account`;
    }

    return errors;
};